export default __webpack_public_path__ + "static/media/guideline_2.68e52089.svg";